import { KeyValueObject } from "../types/general";
import { getColorVariable } from "../utils/helper";
import { SpinnerProps } from "./spinner";

export function getSize(size: SpinnerProps["size"], theme: any): KeyValueObject {
    if (size === "md") {
        return { width: theme.spacing[5], height: theme.spacing[5] };
    }
    if (size === "lg") {
        return { width: "30px", height: "30px" };
    }
    return { width: theme.spacing[3], height: theme.spacing[3] };
}

export function getBorderColor(color: SpinnerProps["color"], theme: any): KeyValueObject {
    if (color) {
        return {
            borderTopColor: getColorVariable(color, theme, {
                gray: theme.colors.gray[400],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][500],
                default: theme.colors.gray[950],
            }),
            borderRightColor: getColorVariable(color, theme, {
                gray: theme.colors.gray[400],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][500],
                default: theme.colors.gray[950],
            }),
            borderBottomColor: getColorVariable(color, theme, {
                gray: theme.colors.gray[400],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][500],
                default: theme.colors.gray[950],
            }),
            borderLeftColor: "transparent",
        };
    }
    return {
        borderTopColor: theme.colors.gray[950],
        borderRightColor: theme.colors.gray[950],
        borderBottomColor: theme.colors.gray[950],
        borderLeftColor: "transparent",
    };
}

export function getMargin(space: SpinnerProps["space"], theme: any): KeyValueObject | null {
    if (space === "sm") {
        return {
            marginTop: theme.spacing[5],
            marginBottom: theme.spacing[5],
        };
    }
    if (space === "md") {
        return {
            marginTop: theme.spacing[10],
            marginBottom: theme.spacing[10],
        };
    }
    if (space === "lg") {
        return {
            marginTop: theme.spacing[20],
            marginBottom: theme.spacing[20],
        };
    }
    return null;
}
